import { render, staticRenderFns } from "./HowItWorks.vue?vue&type=template&id=1da1edc7&scoped=true&"
import script from "./HowItWorks.vue?vue&type=script&lang=ts&"
export * from "./HowItWorks.vue?vue&type=script&lang=ts&"
import style0 from "./HowItWorks.vue?vue&type=style&index=0&id=1da1edc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da1edc7",
  null
  
)

export default component.exports